import React from 'react';
import { useHistory } from 'react-router-dom';

import icon1 from '../../Resources/Images/Redesign/icon1.svg';
import icon2 from '../../Resources/Images/Redesign/icon2.svg';
import icon3 from '../../Resources/Images/Redesign/icon3.svg';
import icon4 from '../../Resources/Images/Redesign/icon4.svg';
import step1Img from '../../Resources/Images/Redesign/step1.png';
import step2Img from '../../Resources/Images/Redesign/step2.png';
import step3Img from '../../Resources/Images/Redesign/step3_cert.png';
import step4Img from '../../Resources/Images/Redesign/step4_cert.png';

const STEPS = [
  {
    num: '01',
    icon: icon1,
    title: '上傳數位證書',
    desc: '您可從電腦上傳電子證書，或直接將檔案拖拉至驗證框內。',
    img: step1Img,
  },
  {
    num: '02',
    icon: icon2,
    title: '輸入驗證代碼',
    desc: '輸入證書寄送電子郵件中所提供的「驗證代碼」，以完成身份驗證。',
    img: step2Img,
  },
  {
    num: '03',
    icon: icon3,
    title: '證書驗證與資料核對',
    desc: '驗證結果：成功、警告、失敗。驗證成功後，請核對畫面上的個人資訊，確認資料無誤。',
    img: step3Img,
  },
  {
    num: '04',
    icon: icon4,
    title: '憑證 QR Code 申請',
    desc: '請打開【數位憑證皮夾APP】掃描畫面上的 QR Code，將憑證儲存至數位憑證皮夾。',
    img: step4Img,
  },
];

export const VCHelpPage: React.FC = () => {
  const history = useHistory();

  return (
    <>
      <h1>使用說明</h1>
      <p className="dc-lead">
        依序完成下列四個步驟，即可順利將數位憑證存入您的手機憑證皮夾。
      </p>

      <h2>如何申請數位憑證？</h2>

      <div className="dc-steps-grid">
        {STEPS.map((step) => (
          <article key={step.num} className="dc-step-card">
            <div className="dc-step-card-top">
              <img
                className="dc-step-card-icon"
                src={step.icon}
                width="44"
                height="44"
                alt={`Step ${step.num}`}
                loading="lazy"
              />
              <span className="dc-step-card-num">STEP {step.num}</span>
            </div>
            <h3>{step.title}</h3>
            <p>{step.desc}</p>
            <figure className="dc-step-card-media">
              <img
                src={step.img}
                width="1000"
                height="667"
                alt={`${step.title}步驟示意圖`}
                loading="lazy"
              />
            </figure>
          </article>
        ))}
      </div>

      <div className="dc-actions">
        <button
          type="button"
          className="dc-button primary"
          onClick={() => history.push('/vc/apply')}
        >
          開始申請
        </button>
        <button
          type="button"
          className="dc-button"
          onClick={() => history.push('/vc')}
        >
          返回功能總覽
        </button>
      </div>
    </>
  );
};

export default VCHelpPage;
